/* eslint-disable @nx/enforce-module-boundaries */
import { Link, Tab, HStack, Tabs } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { forwardRef } from 'react';
import { isMobile } from 'react-device-detect';
export const MyJobsListingTabs = forwardRef(({ active, ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <Tabs defaultIndex={active} {...props} variant="myBridgeVariant" w="100%" mb="2%">
      <HStack>
        <Link
          as={Tab}
          fontWeight="600"
          fontSize={["11px","16px"]}
          href="/jobs/my/saved"
          color="#65676B"
          _selected={{fontWeight:"600", color:'brandPrimary.500'}}
        >
          {t('jobs.savedJobs') || "Saved Jobs"}
        </Link>
        <Link
          as={Tab}
          fontWeight="600"
          fontSize={["11px","16px"]}
          href="/jobs/my/applied"
          color="#65676B"
          _selected={{fontWeight:"600", color:'brandPrimary.500'}}
        >
          {t('jobs.appliedJobs') || "Applied Jobs"}
        </Link>
        <Link
          as={Tab}
          fontWeight="600"
          fontSize={["11px","16px"]}
          href="/jobs/my/track"
          color="#65676B"
          _selected={{fontWeight:"600", color:'brandPrimary.500'}}
        >
          {t('jobs.trackApplications') || "Track your applications"}
        </Link>
        </HStack>
    </Tabs>
  );
});
